import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Icon } from 'semantic-ui-react'; // or any Icon component you use
import GreenArrow from 'assets/images/UI/green_arrow.svg';

// (Optional) A simple fade-in animation
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// A container that places the bar and score on the same row.
const ProgressBarWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top:20px;
`;

// The bar container (takes available space)
const BarContainer = styled.div`
  flex: 1;
  position: relative;
  height: 6px;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 10px;
  animation: ${fadeIn} 0.5s ease;
`;

// The full bar gradient (drawn as if the bar were 100% filled)
const Bar = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #F8A8B0 0%, #FECD8D 58.35%, #95E6D2 111.51%);
  background-size: 100% 100%;
`;

// The mask covers the right-hand (unfilled) part of the bar
const Mask = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: ${props => 100 - props.fill}%;
  background-color: #DFDFDF;
`;

// The score text (with an icon) that will be shown to the right of the bar.
const Score = styled.div`
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1D9A7D;
;
`;

// The icon that will be shown to the left of the score.
const IMG = styled.img`
  width: 20px;
  margin-right: 5px;
`;

// Our complete component
const MyProgressBar = ({ roiScore, maxScore }) => {
  const fillPercent = (roiScore / maxScore) * 100;

  return (
    <ProgressBarWrapper>
      <BarContainer>
        <Bar />
        <Mask fill={fillPercent} />
      </BarContainer>
      <Score>
        <IMG src={GreenArrow} />
        {roiScore}%
      </Score>
    </ProgressBarWrapper>
  );
};

export default MyProgressBar;
